import React from "react";

interface KxdEnergyModelIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const KxdEnergyModelIcon: React.FC<KxdEnergyModelIconProps> = ({
  width = 20,
  height = 20,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M18.333 0C18.775 0 19.1992 0.175721 19.5117 0.488281C19.8243 0.800842 20 1.22496 20 1.66699V18.333C20 18.775 19.8243 19.1992 19.5117 19.5117C19.1992 19.8243 18.775 20 18.333 20H1.66699C1.22496 20 0.800842 19.8243 0.488281 19.5117C0.175721 19.1992 0 18.775 0 18.333V1.66699C0 1.22496 0.175721 0.800842 0.488281 0.488281C0.800842 0.175721 1.22496 0 1.66699 0H18.333ZM10.0547 4C8.3897 4.00008 6.96678 4.60548 5.78613 5.78613C4.60548 6.96678 4.00008 8.3897 4 10.0547C4 11.7198 4.60541 13.1435 5.78613 14.3242C6.96675 15.5048 8.38978 16.1103 10.0547 16.1104C11.7198 16.1104 13.1435 15.5049 14.3242 14.3242C15.5049 13.1435 16.1104 11.7198 16.1104 10.0547C16.1103 8.38978 15.5048 6.96675 14.3242 5.78613C13.1435 4.60541 11.7198 4 10.0547 4ZM10.6602 9.00781H12.6953L9.75195 14.8994V11.1025H7.63281L10.6602 5.21094V9.00781Z" fill="#002366"/>
    </svg>
  );
};

export default KxdEnergyModelIcon;
